import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { initSentry } from './sentry'
import App from './App.jsx'

// Initialize error tracking (no-op if VITE_SENTRY_DSN is not set)
initSentry()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Service worker registration is handled by <UpdatePrompt /> in App.jsx, which
// calls useRegisterSW() from virtual:pwa-register/react. We use prompt mode
// (see vite.config.js) so users get a "Reload" banner rather than a silent
// swap mid-session. Push notification handlers are merged into the main SW
// via importScripts in vite.config.js.
